import { useQuery } from 'convex/react';
import { Link } from 'react-router-dom';
import { api } from '../../../../convex/_generated/api';

const DAY = 86_400_000;

export default function Dashboard() {
  const work = useQuery(api.jobs.dueWork, { before: Date.now() + 60 * DAY });
  const open = useQuery(api.sync.openReconciliations, {});

  if (work === undefined) return <p className="muted">Loading…</p>;

  const overdue = work.filter((w) => w.overdue);
  const items = work.reduce((n, w) => n + w.job.assetCount, 0);

  return (
    <>
      <h1>Due work</h1>

      <div className="tiles">
        <div className="tile"><span className="n">{work.length}</span><span className="l">sites to book</span></div>
        <div className="tile"><span className="n">{items}</span><span className="l">items due</span></div>
        <div className="tile"><span className="n">{overdue.length}</span><span className="l">overdue</span></div>
        <div className="tile"><span className="n">{open?.length ?? 0}</span><span className="l">need attention</span></div>
      </div>

      {open && open.length > 0 ? (
        <div className="card">
          <strong>{open.length} record{open.length === 1 ? '' : 's'} could not be filed automatically.</strong>
          <p className="muted small">
            Usually a tag number used twice, or a capture that referenced something deleted.
            Nothing is lost — each one is waiting for a decision.
          </p>
        </div>
      ) : null}

      <h2>Next 60 days</h2>
      <div className="card">
        <table>
          <thead><tr><th>Due</th><th>Client</th><th>Site</th><th>Items</th></tr></thead>
          <tbody>
            {work.map(({ job, site, client, overdue: isLate }) => (
              <tr key={job._id}>
                <td className={isLate ? 'overdue' : ''}>
                  {new Date(job.dueAt).toLocaleDateString('en-AU')}
                  {isLate ? ' · overdue' : ''}
                </td>
                <td>
                  {client ? <Link to={`/clients/${client._id}`}>{client.name}</Link> : '—'}
                </td>
                <td>{site?.name ?? '—'}</td>
                <td>{job.assetCount}</td>
              </tr>
            ))}
            {work.length === 0 ? (
              <tr><td colSpan={4} className="muted">
                Nothing scheduled yet. Jobs appear here automatically as soon as tests are logged.
              </td></tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </>
  );
}
